import { render } from "./Department.vue?vue&type=template&id=3fe771ee&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"

import "./Department.vue?vue&type=style&index=0&id=3fe771ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3fe771ee"

export default script